import { isArray } from 'lodash';

const getPackageDetailsRoute = (currentPlayer, search, packId) => {
  let weeks = null;

  if (currentPlayer?.stage?.offers?.length) {
    weeks = currentPlayer.stage.offers.map((offer) => `weeks=${offer.weekId}`).join('&');
  } else if (search?.weeks) {
    weeks = isArray(search.weeks)
      ? search.weeks.map((week) => `weeks=${week}`).join('&')
      : `weeks=${search.weeks}`;
  }

  return weeks ? `/camp/${packId}?${weeks}` : `/camp/${packId}`;
};

export default getPackageDetailsRoute;
